import {fetchJSONByGet, fetchJSONByPost, fetchJSONByPut, fetchJSONByDel} from './index.js'
// 修改用户个人密码
export const updatePwdApi = (body) => fetchJSONByPost('/admin-api/system/auth/update-password', body)